import React from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {Alert} from "react-bootstrap";
import moment from "moment";

const WidgetDelayInformationPc = ({dashboard, exhibitionState, callbackAction, user, claim, t}) => {
    let showInfo = false;
    let dateToRun = null;

    if(dashboard?.turnOnPcTime) {
        showInfo = dashboard?.turnOnPcTime !== "0001-01-01T00:00:00";
        if(showInfo === true) {
            const startDate = moment(dashboard.turnOnPcTime);
            const currentDate = moment(new Date());
            dateToRun = startDate.diff(currentDate, 'seconds');
        }
    }

    return (
        showInfo ? (
                <Alert variant={"warning"}>
                    <i className="fas fa-info"/> &nbsp; <b>{ t('delay-info-device-pc') } { dateToRun } sek.</b>
                </Alert>
        ) : (<React.Fragment/>)
    )
}
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetDelayInformationPc));
